/* Gulelalah storefront scripts (ported from the Arena React build) */
(function () {
  'use strict';
  var GL = window.GL || {};
  var doc = document;
  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };

  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\u0022/g, '&quot;');
  }
  function money(cents) {
    var n = String(Math.round(cents / 100)), out = '', i;
    for (i = 0; i < n.length; i++) { if (i && (n.length - i) % 3 === 0) out += ','; out += n.charAt(i); }
    var f = GL.moneyFormat || 'Rs. {{amount_no_decimals}}';
    var a = f.indexOf('{{'), b = f.indexOf('}}');
    return a > -1 && b > a ? f.slice(0, a) + out + f.slice(b + 2) : 'Rs. ' + out;
  }
  function imgUrl(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var ICON_CHECK = `<svg class='gl-icon' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'><path d='M20 6 9 17l-5-5'/></svg>`;
  var ICON_ARROW = `<svg class='gl-icon gl-arrow-right' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.4' stroke-linecap='round' stroke-linejoin='round'><path d='M5 12h14M12 5l7 7-7 7'/></svg>`;

  /* ---------- Toast ---------- */
  function toast(msg) {
    var old = $('.gl-toast'); if (old) old.remove();
    var el = doc.createElement('div');
    el.className = 'gl-toast'; el.setAttribute('role', 'status');
    el.innerHTML = ICON_CHECK + '<p>' + esc(msg) + '</p>';
    doc.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 2900);
  }

  /* ---------- Layers (drawers / modals) ---------- */
  function layer(name) { return $(`[data-gl-layer='${name}']`); }
  function closeLayers(except) {
    $$('[data-gl-layer].is-open').forEach(function (el) {
      if (el.getAttribute('data-gl-layer') !== except) { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); }
    });
    if (!$('[data-gl-layer].is-open')) doc.body.classList.remove('gl-lock');
  }
  function openLayer(name) {
    var el = layer(name); if (!el) return;
    closeLayers(name);
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    doc.body.classList.add('gl-lock');
    var f = $('[data-gl-focus]', el);
    if (f) setTimeout(function () { f.focus(); }, 350);
  }

  /* ---------- Cart ---------- */
  var cartState = null;
  function cartJSON() { return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function renderCart(c) {
    cartState = c;
    $$('[data-gl-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; });
    var body = $('[data-gl-cart-body]'), foot = $('[data-gl-cart-foot]'), title = $('[data-gl-cart-title]');
    if (title) title.textContent = '(' + c.item_count + ')';
    if (!body) return;
    if (!c.items.length) {
      body.innerHTML = `<div class='gl-empty'><h4>Your bag is empty</h4><p>Discover the season's solid silks, lawns and hand-worked classics.</p><a class='gl-btn gl-btn--dark' href='${esc(GL.collectionsUrl || '/collections/all')}'>Continue Shopping</a></div>`;
      if (foot) foot.hidden = true;
      return;
    }
    var th = parseInt(body.getAttribute('data-threshold') || '0', 10) * 100;
    var ship = '';
    if (th > 0) {
      var rem = th - c.total_price, pct = Math.min(100, Math.round(c.total_price / th * 100));
      ship = `<div class='gl-ship'><p>${rem > 0 ? 'Add <b>' + money(rem) + '</b> more for complimentary shipping' : 'You have unlocked <b>complimentary shipping</b>'}</p><div class='gl-ship__bar'><i style='width:${pct}%'></i></div></div>`;
    }
    body.innerHTML = ship + c.items.map(function (i) {
      return `<div class='gl-line'>
        <a href='${esc(i.url)}'>${i.image ? `<img src='${esc(imgUrl(i.image, 200))}' alt='${esc(i.product_title)}' width='84' height='108' loading='lazy'>` : ''}</a>
        <div style='flex:1;min-width:0'>
          <a href='${esc(i.url)}' class='gl-line__t'>${esc(i.product_title)}</a>
          ${i.variant_title ? `<p class='gl-line__v'>${esc(i.variant_title)}</p>` : ''}
          <div class='gl-line__r'>
            <div class='gl-qty'><button type='button' data-gl-qty='-1' data-key='${esc(i.key)}' aria-label='Decrease quantity'>-</button><span>${i.quantity}</span><button type='button' data-gl-qty='1' data-key='${esc(i.key)}' aria-label='Increase quantity'>+</button></div>
            <b>${money(i.final_line_price)}</b>
          </div>
          <button type='button' class='gl-rm' data-gl-remove='${esc(i.key)}' style='margin-top:10px'>Remove</button>
        </div></div>`;
    }).join('');
    if (foot) {
      foot.hidden = false;
      var sub = $('[data-gl-cart-sub]', foot); if (sub) sub.textContent = money(c.total_price);
    }
  }
  function refreshCart() { return cartJSON().then(renderCart).catch(function () {}); }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () { toast('Could not update your bag'); });
  }
  function addToCart(id, qty, btn) {
    if (btn) btn.disabled = true;
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Could not add to bag'); return j; }); })
      .then(function () { return cartJSON(); })
      .then(function (c) { renderCart(c); openLayer('cart'); })
      .catch(function (err) { toast(err.message); })
      .then(function () { if (btn) btn.disabled = false; });
  }

  /* ---------- Wishlist (localStorage) ---------- */
  var WK = 'gl_wishlist';
  function wishGet() { try { return JSON.parse(localStorage.getItem(WK) || '[]'); } catch (e) { return []; } }
  function syncWish() {
    var a = wishGet();
    $$('[data-gl-wish]').forEach(function (b) { b.classList.toggle('is-active', a.indexOf(b.getAttribute('data-gl-wish')) > -1); });
    $$('[data-gl-wish-count]').forEach(function (el) { el.textContent = a.length; el.hidden = !a.length; });
  }
  function toggleWish(h, title) {
    var a = wishGet(), i = a.indexOf(h);
    if (i > -1) { a.splice(i, 1); toast('Removed from wishlist'); } else { a.push(h); toast((title || 'Item') + ' saved to wishlist'); }
    try { localStorage.setItem(WK, JSON.stringify(a)); } catch (e) {}
    syncWish(); renderWishlist();
  }
  function renderWishlist() {
    var body = $('[data-gl-wish-body]'); if (!body) return;
    var a = wishGet();
    if (!a.length) { body.innerHTML = `<div class='gl-empty'><h4>Nothing saved yet</h4><p>Tap the heart on any piece to keep it here.</p></div>`; return; }
    Promise.all(a.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); })).then(function (list) {
      body.innerHTML = list.filter(Boolean).map(function (p) {
        var single = p.variants.length === 1 && p.available;
        return `<div class='gl-line'><a href='${esc(p.url)}'><img src='${esc(imgUrl(p.featured_image, 200))}' alt='${esc(p.title)}' width='84' height='108' loading='lazy'></a><div style='flex:1;min-width:0'><a href='${esc(p.url)}' class='gl-line__t'>${esc(p.title)}</a><p class='gl-line__v'>${money(p.price)}</p><div class='gl-line__r'>${single ? `<button type='button' class='gl-btn gl-btn--dark' style='padding:10px 16px' data-gl-add='${p.variants[0].id}'>Add to Bag</button>` : `<a class='gl-btn gl-btn--outline' style='padding:10px 16px' href='${esc(p.url)}'>${p.available ? 'Choose Options' : 'Sold Out'}</a>`}<button type='button' class='gl-rm' data-gl-wish='${esc(p.handle)}' data-gl-title='${esc(p.title)}'>Remove</button></div></div></div>`;
      }).join('');
    });
  }

  /* ---------- Quick view ---------- */
  function optNames(p) { return (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; }); }
  function optValues(p, idx) { var seen = [], k = 'option' + (idx + 1); p.variants.forEach(function (v) { if (seen.indexOf(v[k]) < 0) seen.push(v[k]); }); return seen; }
  function openQuick(handle) {
    var box = $('[data-gl-quick-body]'); if (!box) return;
    box.innerHTML = `<div class='gl-success'><p>Loading...</p></div>`;
    openLayer('quick');
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) { buildQuick(p, box); }).catch(function () { box.innerHTML = `<div class='gl-success'><p>Could not load this piece.</p></div>`; });
  }
  function buildQuick(p, box) {
    var names = optNames(p), sel = [];
    var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    names.forEach(function (n, i) { sel.push(first['option' + (i + 1)]); });
    var hasOpts = !(p.variants.length === 1 && p.variants[0].title === 'Default Title');
    function find() { return p.variants.filter(function (v) { return names.every(function (n, i) { return v['option' + (i + 1)] === sel[i]; }); })[0]; }
    function avail(i, val) { return p.variants.some(function (v) { return v.available && v['option' + (i + 1)] === val && names.every(function (n, j) { return j === i || v['option' + (j + 1)] === sel[j]; }); }); }
    function draw() {
      var v = find(), img = (v && v.featured_image && v.featured_image.src) || p.featured_image || '';
      var sale = v && v.compare_at_price && v.compare_at_price > v.price;
      var opts = hasOpts ? names.map(function (n, i) {
        return `<div><p class='gl-optname'>${esc(n)}<span>${esc(sel[i])}</span></p><div class='gl-vals'>${optValues(p, i).map(function (val) { return `<button type='button' class='gl-val${val === sel[i] ? ' is-active' : ''}${avail(i, val) ? '' : ' is-off'}' data-qi='${i}' data-qv='${esc(val)}'>${esc(val)}</button>`; }).join('')}</div></div>`;
      }).join('') : '';
      var can = v && v.available;
      box.innerHTML = `<div class='gl-qv'><div class='gl-qv__img'><img src='${esc(imgUrl(img, 900))}' alt='${esc(p.title)}'></div><div class='gl-qv__txt'>
        ${p.type ? `<p class='gl-card__eyebrow'>${esc(p.type)}</p>` : ''}<h3 style='margin-top:8px'>${esc(p.title)}</h3>
        <p class='gl-price${sale ? ' is-sale' : ''}' style='justify-content:flex-start;margin-top:12px'><b style='font-size:20px'>${v ? money(v.price) : ''}</b>${sale ? `<s>${money(v.compare_at_price)}</s>` : ''}</p>
        <div class='gl-opts'>${opts}</div>
        <div class='gl-buy'><button type='button' class='gl-btn gl-btn--dark' data-qadd ${can ? '' : 'disabled'}>${can ? 'Add to Bag' : (v ? 'Sold Out' : 'Unavailable')}</button></div>
        <p style='margin-top:20px'><a class='gl-link-sweep' style='font-size:11px;text-transform:uppercase;letter-spacing:.22em' href='${esc(p.url)}'>View full details</a></p>
      </div></div>`;
    }
    box.onclick = function (e) {
      var b = e.target.closest('[data-qi]');
      if (b) { sel[parseInt(b.getAttribute('data-qi'), 10)] = b.getAttribute('data-qv'); draw(); return; }
      var a = e.target.closest('[data-qadd]');
      if (a) { var v = find(); if (v) addToCart(v.id, 1, a); }
    };
    draw();
  }

  /* ---------- Predictive search ---------- */
  var searchTimer;
  function suggest(q) {
    clearTimeout(searchTimer);
    var out = $('[data-gl-search-out]'), def = $('[data-gl-search-default]');
    if (!out || !def) return;
    if (!q.trim()) { out.innerHTML = ''; def.hidden = false; return; }
    def.hidden = true;
    searchTimer = setTimeout(function () {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
          if (!ps.length) { out.innerHTML = `<p class='gl-display' style='margin-top:24px;font-size:22px;font-style:italic;color:rgba(25,24,22,.7)'>Nothing found - try another word.</p>`; return; }
          out.innerHTML = `<p class='gl-eyebrow' style='margin-top:24px'>${ps.length} result${ps.length === 1 ? '' : 's'}</p><div style='margin-top:12px'>` + ps.map(function (p) {
            var im = (p.featured_image && p.featured_image.url) || p.image || '';
            return `<a class='gl-sr' href='${esc(p.url)}'><img src='${esc(imgUrl(im, 120))}' alt='' width='56' height='72' loading='lazy'><span><b>${esc(p.title)}</b><small>${esc(p.type || '')}</small></span><span class='p'>${money(parseFloat(p.price) * 100)}</span></a>`;
          }).join('') + `</div><p style='margin-top:24px'><a class='gl-btn gl-btn--outline' href='/search?q=${encodeURIComponent(q)}&type=product'>View all results ${ICON_ARROW}</a></p>`;
        }).catch(function () {});
    }, 220);
  }

  /* ---------- Section initialisers ---------- */
  function once(fn) { return function (el) { if (el.__gl) return; el.__gl = 1; fn(el); }; }

  var io;
  function initReveal(root) {
    var els = $$('.gl-reveal:not(.is-visible)', root);
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-visible'); }); return; }
    if (!io) io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  var initAnn = once(function (root) {
    var m = $$('[data-gl-ann-msg]', root); if (m.length < 2) return;
    var i = 0;
    setInterval(function () { m[i].classList.remove('is-active'); i = (i + 1) % m.length; m[i].classList.add('is-active'); }, 4200);
  });

  var initHeader = once(function (h) {
    function onScroll() { h.classList.toggle('is-scrolled', window.scrollY > 24); }
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    var items = $$('[data-gl-mega-item]', h), nav = $('[data-gl-nav]', h), t;
    function closeAll() { items.forEach(function (i) { i.classList.remove('is-open'); var p = $('[data-gl-mega-panel]', i); if (p) p.classList.remove('is-open'); }); }
    function open(item) { clearTimeout(t); items.forEach(function (i) { var on = i === item, p = $('[data-gl-mega-panel]', i); i.classList.toggle('is-open', on); if (p) p.classList.toggle('is-open', on); }); }
    items.forEach(function (li) {
      var hasPanel = !!$('[data-gl-mega-panel]', li);
      li.addEventListener('mouseenter', function () { if (hasPanel) open(li); else { clearTimeout(t); closeAll(); } });
      li.addEventListener('focusin', function () { if (hasPanel) open(li); else closeAll(); });
    });
    if (nav) nav.addEventListener('mouseleave', function () { clearTimeout(t); t = setTimeout(closeAll, 140); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  });

  var initHero = once(function (root) {
    var slides = $$('[data-gl-slide]', root), texts = $$('[data-gl-slide-txt]', root), dots = $$('[data-gl-dot]', root), count = $('[data-gl-hero-count]', root);
    var n = slides.length, cur = 0, timer; if (!n) return;
    function go(i) {
      cur = (i + n) % n;
      [slides, texts, dots].forEach(function (list) { list.forEach(function (el, k) { el.classList.toggle('is-active', k === cur); }); });
      if (count) count.textContent = '0' + (cur + 1) + ' / 0' + n;
    }
    function stop() { clearInterval(timer); }
    function play() { stop(); if (n > 1) timer = setInterval(function () { go(cur + 1); }, 6000); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); play(); }); });
    var pv = $('[data-gl-hero-prev]', root), nx = $('[data-gl-hero-next]', root);
    if (pv) pv.addEventListener('click', function () { go(cur - 1); play(); });
    if (nx) nx.addEventListener('click', function () { go(cur + 1); play(); });
    root.addEventListener('mouseenter', function () { stop(); root.classList.add('is-paused'); });
    root.addEventListener('mouseleave', function () { root.classList.remove('is-paused'); play(); });
    go(0); play();
  });

  var initTabs = once(function (root) {
    var tabs = $$('[data-gl-tab]', root), panels = $$('[data-gl-panel]', root);
    tabs.forEach(function (tb) {
      tb.addEventListener('click', function () {
        var i = tb.getAttribute('data-gl-tab');
        tabs.forEach(function (x) { x.classList.toggle('is-active', x === tb); x.setAttribute('aria-selected', x === tb ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-gl-panel') !== i; });
      });
    });
  });

  var initTrack = once(function (root) {
    var tr = $('[data-gl-track]', root), prev = $('[data-gl-prev]', root), next = $('[data-gl-next]', root), rail = $('[data-gl-rail]', root);
    if (!tr) return;
    function upd() {
      var max = tr.scrollWidth - tr.clientWidth;
      if (prev) prev.disabled = tr.scrollLeft < 8;
      if (next) next.disabled = tr.scrollLeft > max - 8;
      if (rail) rail.style.width = (18 + (max > 0 ? tr.scrollLeft / max : 0) * 82) + '%';
    }
    tr.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    if (prev) prev.addEventListener('click', function () { tr.scrollBy({ left: -tr.clientWidth * 0.75, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { tr.scrollBy({ left: tr.clientWidth * 0.75, behavior: 'smooth' }); });
    var down = false, sx = 0, sl = 0, moved = false;
    tr.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') return; down = true; moved = false; sx = e.clientX; sl = tr.scrollLeft; });
    window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4) { moved = true; tr.classList.add('is-drag'); } tr.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', function () { if (!down) return; down = false; tr.classList.remove('is-drag'); });
    tr.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  });

  var initPDP = once(function (root) {
    var jEl = $('[data-gl-product-json]', root); if (!jEl) return;
    var p; try { p = JSON.parse(jEl.textContent); } catch (e) { return; }
    var form = $('[data-gl-form]', root), idIn = $('[name=id]', form), priceEl = $('[data-gl-price]', root), atc = $('[data-gl-atc]', root), atcLabel = $('[data-gl-atc-label]', root), err = $('[data-gl-err]', root);
    var main = $('[data-gl-main]', root), thumbs = $$('[data-gl-thumb]', root), groups = $$('[data-gl-optgroup]', root), qtyIn = $('[data-gl-qty-input]', root);
    var sel = groups.map(function (g) { var a = $('.is-active', g); return a ? a.getAttribute('data-value') : ''; });
    function find() { return p.variants.filter(function (v) { return sel.every(function (s, i) { return v['option' + (i + 1)] === s; }); })[0]; }
    function showImg(th) {
      if (!th || !main) return;
      thumbs.forEach(function (x) { x.classList.toggle('is-active', x === th); });
      main.removeAttribute('srcset'); main.src = th.getAttribute('data-src');
    }
    thumbs.forEach(function (th) { th.addEventListener('click', function () { showImg(th); }); });
    function update() {
      var v = find();
      groups.forEach(function (g, i) {
        var lab = $('[data-gl-optval]', g); if (lab) lab.textContent = sel[i];
        $$('.gl-val', g).forEach(function (b) {
          var val = b.getAttribute('data-value');
          var ok = p.variants.some(function (x) { return x.available && x['option' + (i + 1)] === val && sel.every(function (s, j) { return j === i || x['option' + (j + 1)] === s; }); });
          b.classList.toggle('is-off', !ok);
        });
      });
      if (idIn && v) idIn.value = v.id;
      if (priceEl) {
        if (v) {
          var sale = v.compare_at_price && v.compare_at_price > v.price;
          priceEl.classList.toggle('is-sale', !!sale);
          priceEl.innerHTML = '<b>' + money(v.price) + '</b>' + (sale ? '<s>' + money(v.compare_at_price) + '</s>' : '');
        }
      }
      if (atc) {
        var can = v && v.available;
        atc.disabled = !can;
        if (atcLabel) atcLabel.textContent = can ? 'Add to Bag' : (v ? 'Sold Out' : 'Unavailable');
      }
      if (v && window.history && history.replaceState) { try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); } catch (e) {} }
      var mid = v && v.featured_media && v.featured_media.id;
      if (mid) thumbs.forEach(function (th) { if (th.getAttribute('data-media-id') === String(mid)) showImg(th); });
    }
    groups.forEach(function (g, i) {
      $$('.gl-val', g).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('.gl-val', g).forEach(function (x) { x.classList.toggle('is-active', x === b); });
          sel[i] = b.getAttribute('data-value'); update();
        });
      });
    });
    $$('[data-gl-step]', root).forEach(function (b) {
      b.addEventListener('click', function () { var q = Math.max(1, (parseInt(qtyIn.value, 10) || 1) + parseInt(b.getAttribute('data-gl-step'), 10)); qtyIn.value = q; });
    });
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = find(); if (!v || !v.available) return;
      if (err) err.hidden = true;
      addToCart(v.id, parseInt(qtyIn ? qtyIn.value : 1, 10) || 1, atc);
    });
    update();
  });

  var initRecs = once(function (el) {
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (t) {
      var d = new DOMParser().parseFromString(t, 'text/html'), n = $('[data-gl-recs]', d);
      if (n && n.innerHTML.trim()) { el.innerHTML = n.innerHTML; var w = el.closest('[data-gl-recs-wrap]'); if (w) w.hidden = false; initReveal(el); syncWish(); }
    }).catch(function () {});
  });

  var initCustom = once(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('button[type=submit]', form); if (btn) btn.disabled = true;
      fetch(form.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error('fail'); var f = $('[data-gl-custom-form-wrap]'), s = $('[data-gl-custom-success]'); if (f) f.hidden = true; if (s) s.hidden = false; })
        .catch(function () { form.submit(); });
    });
  });

  var initFilters = once(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });

  function initAll(root) {
    root = root || doc;
    initReveal(root);
    $$('[data-gl-ann]', root).forEach(initAnn);
    $$('[data-gl-header]', root).forEach(initHeader);
    $$('[data-gl-hero]', root).forEach(initHero);
    $$('[data-gl-tabs]', root).forEach(initTabs);
    $$('[data-gl-track-wrap]', root).forEach(initTrack);
    $$('[data-gl-pdp]', root).forEach(initPDP);
    $$('[data-gl-recs]', root).forEach(function (el) { if (el.getAttribute('data-url')) initRecs(el); });
    $$('[data-gl-custom-form]', root).forEach(initCustom);
    $$('[data-gl-filter-form]', root).forEach(initFilters);
    syncWish();
  }

  /* ---------- Global events ---------- */
  doc.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var el;
    if ((el = t.closest('[data-gl-open]'))) { e.preventDefault(); var nm = el.getAttribute('data-gl-open'); if (nm === 'wish') renderWishlist(); openLayer(nm); return; }
    if ((el = t.closest('[data-gl-close]'))) { e.preventDefault(); closeLayers(); return; }
    if ((el = t.closest('[data-gl-add]'))) { e.preventDefault(); addToCart(el.getAttribute('data-gl-add'), 1, el); return; }
    if ((el = t.closest('[data-gl-quick]'))) { e.preventDefault(); openQuick(el.getAttribute('data-gl-quick')); return; }
    if ((el = t.closest('[data-gl-wish]'))) { e.preventDefault(); toggleWish(el.getAttribute('data-gl-wish'), el.getAttribute('data-gl-title')); return; }
    if ((el = t.closest('[data-gl-acc]'))) { var li = el.closest('li'); if (li) li.classList.toggle('is-open'); return; }
    if ((el = t.closest('[data-gl-qty]'))) {
      var key = el.getAttribute('data-key');
      var item = cartState && cartState.items.filter(function (i) { return i.key === key; })[0];
      if (item) changeLine(key, item.quantity + parseInt(el.getAttribute('data-gl-qty'), 10));
      return;
    }
    if ((el = t.closest('[data-gl-remove]'))) { changeLine(el.getAttribute('data-gl-remove'), 0); return; }
    if ((el = t.closest('[data-gl-chip]'))) { var inp = $('[data-gl-focus]'); if (inp) { inp.value = el.getAttribute('data-gl-chip'); inp.focus(); suggest(inp.value); } return; }
  });
  doc.addEventListener('input', function (e) { if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-gl-focus')) suggest(e.target.value); });
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLayers(); });
  doc.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  function boot() { initAll(doc); refreshCart(); renderWishlist(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
  window.GLTheme = { openLayer: openLayer, closeLayers: closeLayers, toast: toast, refreshCart: refreshCart };
})();
